import React, { lazy } from 'react';
export function DeckScreens() {
  return <section className="py-16 lg:py-24 px-4 sm:px-6 lg:px-8 bg-white" data-id="element-1194" data-mp="2yfsph1effdzl">
      <div className="max-w-7xl mx-auto" data-id="element-1195" data-mp="1dxtjxvs744ss">
        <div className="text-center max-w-3xl mx-auto mb-12" data-id="element-1196" data-mp="1iw4t04ao2b9y">
          <h2 className="text-3xl sm:text-4xl font-bold text-navy-900 tracking-normal mb-6" data-id="element-1197" data-mp="1iujzmi038ydo">
            Glass Deck Railing, Window Screens & Door Screens
          </h2>
          <p className="text-lg text-slate-600" data-id="element-1198" data-mp="1sv42fp39aay0">
            Kosin's Glass can help with more than windows. The team supplies
            custom glass panels for deck railings and can repair or replace
            damaged window screens and door screens.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-1199" data-mp="26lfuxp3r6bpo">
          <article className="bg-slate-50 rounded-lg border border-slate-200 flex flex-col h-full overflow-hidden anim-on-scroll" data-id="element-1200" data-mp="26ntplwuitlwp">
            <div className="aspect-[5/3] w-full overflow-hidden" data-id="element-1201" data-mp="2gjnaq4mb2nq3">
              <img src="https://cdn.magicpatterns.com/uploads/htoXmF8zKkRWKHtScGxMiw/respic4.webp" alt="Custom tempered glass panels installed in a residential deck railing" className="w-full h-full object-cover" loading="lazy" data-id="element-1202" data-mp="2ghsrcuqon3o4" />
            </div>
            <div className="p-8 flex flex-col flex-grow" data-id="element-1203" data-mp="1ojwt142vxe7q">
              <h3 className="text-2xl font-bold text-navy-900 mb-4" data-id="element-1204" data-mp="1olga2wwd7tak">
                Glass Deck Railing Panels
              </h3>
              <p className="text-slate-600 text-lg mb-8 flex-grow" data-id="element-1205" data-mp="2gat5w4oy3iv0">
                Custom glass panels for deck railings help homeowners, builders
                and contractors create modern outdoor spaces with open views,
                durable tempered glass and a clean finished look.
              </p>
              <div data-id="element-1206" data-mp="3405eb2cg7mw9">
                <a href="/deckglass.html" className="inline-flex items-center justify-center bg-white border-2 border-brandBlue-600 text-brandBlue-600 hover:bg-brandBlue-50 font-bold text-lg py-3 px-8 rounded-lg transition-colors" data-id="element-1207" data-mp="340nh6htm8zd5">
                  Learn About Glass Deck Railing
                </a>
              </div>
            </div>
          </article>
          <article className="bg-slate-50 rounded-lg border border-slate-200 flex flex-col h-full overflow-hidden anim-on-scroll" data-id="element-1208" data-mp="nlag0b2dc6t3">
            <div className="aspect-[5/3] w-full overflow-hidden" data-id="element-1209" data-mp="sjlks7dt3r4g">
              <img src="https://cdn.magicpatterns.com/uploads/qrNnHAJR5sN6DHwJJakntj/WindoDoor.png" alt="Kosin's Glass technician replacing screen material on a residential window screen frame" className="w-full h-full object-cover" loading="lazy" data-id="element-1210" data-mp="eklwx1y4bg9c" />
            </div>
            <div className="p-8 flex flex-col flex-grow" data-id="element-1211" data-mp="9odos8ic8nbo">
              <h3 className="text-2xl font-bold text-navy-900 mb-4" data-id="element-1212" data-mp="1z2sasl1z1w3h">
                Window & Door Screens
              </h3>
              <p className="text-slate-600 text-lg mb-8 flex-grow" data-id="element-1213" data-mp="23zsdqn3iyiqd">
                Damaged screens can be repaired or replaced by replacing the
                screen material, helping improve airflow and everyday use.
              </p>
              <div data-id="element-1214" data-mp="22rr7kdhdi14">
                <a href="#quote" className="inline-flex items-center justify-center bg-white border-2 border-brandBlue-600 text-brandBlue-600 hover:bg-brandBlue-50 font-bold text-lg py-3 px-8 rounded-lg transition-colors" data-id="element-1215" data-mp="2433y9owm04d">
                  Ask About Screen Repair
                </a>
              </div>
            </div>
          </article>
        </div>
      </div>
    </section>;
}